import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store';
import { addNotification } from '../../../store/slices/uiSlice';
import './BusinessDetails.css';

const BusinessDetails: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const fullName = user ? `${user.firstName} ${user.lastName}` : 'Guest User';
  const companyVal = user ? user.companyName : 'Apex B2B Solutions';
  const emailVal = user ? user.email : 'keshav.singh@gmail.com';
  const phoneVal = user ? user.phone : '+91-9667722651';

  return (
    <div className="account-business-page">
      <div className="account-business-container">
        
        <div className="account-layout">
          
          {/* Sidebar */}
          <aside className="account-sidebar-panel">
            <div className="account-user-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="user-icon">
                <path d="M20 21a8 8 0 0 0-16 0"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              {fullName}
            </div>
            <nav className="account-nav-list">
              <Link to="/account/addresses" className="account-nav-item">
                <span className="icon">⌖</span> My Addresses
              </Link>
              <Link to="/account/orders" className="account-nav-item">
                <span className="icon">▣</span> My Order
              </Link>
              <Link to="/account/rfqs" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span> My RFQ's
              </Link>
              <Link to="/account/business" className="account-nav-item active">
                <span className="icon green-icon">▤</span> My Business Details
              </Link>
              <Link to="/account/wishlist" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></span> My Wishlist
              </Link>
              <Link to="/logout" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></span> Log-out
              </Link>
            </nav>
          </aside>

          {/* Main Content */}
          <main className="account-main-content">
            
            <div className="business-details-wrapper">
              <h2 className="business-details-title">MY BUSINESS DETAILS</h2>
              
              <form className="business-details-form" onSubmit={(e) => { e.preventDefault(); dispatch(addNotification({ type: 'success', title: 'Success', message: 'Business details updated successfully!' })); }}>
                
                <div className="form-row-split">
                  <div className="form-group">
                    <label>Enter GST Number*</label>
                    <input type="text" placeholder="07AAAAA1111A1Z1" defaultValue="07AAAAA1111A1Z1" required />
                  </div>
                  <div className="form-group">
                    <label>Business Name*</label>
                    <input type="text" placeholder="e.g. Apex B2B Solutions" defaultValue={companyVal} required />
                  </div>
                </div>

                <div className="form-row-split">
                  <div className="form-group">
                    <label>Business Phone*</label>
                    <input type="text" defaultValue={phoneVal} required />
                  </div>
                  <div className="form-group">
                    <label>Business Email ID (Optional)</label>
                    <input type="email" defaultValue={emailVal} />
                  </div>
                </div>

                <div className="form-group full-width">
                  <label>Address</label>
                  <input type="text" placeholder="Road No. 13/x, Industrial Area Phase 2" defaultValue="Road No. 13/x, Industrial Area Phase 2" />
                </div>

                <div className="form-row-split">
                  <div className="form-group">
                    <label>Pin code*</label>
                    <input type="text" placeholder="110024" defaultValue="110024" required />
                  </div>
                  <div className="form-group">
                    <label>City/District/Town*</label>
                    <input type="text" placeholder="New Delhi" defaultValue="New Delhi" required />
                  </div>
                </div>

                <div className="form-row-split">
                  <div className="form-group">
                    <label>State*</label>
                    <div className="select-wrapper">
                      <select defaultValue="Delhi">
                        <option value="Delhi">Delhi</option>
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Karnataka">Karnataka</option>
                      </select>
                      <span className="select-arrow">▼</span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Country*</label>
                    <input type="text" defaultValue="India" readOnly className="readonly-input" />
                  </div>
                </div>

                <div className="form-actions-row">
                  <button type="button" className="btn-cancel">CANCEL</button>
                  <button type="submit" className="btn-save">SAVE CHANGES</button>
                </div>

              </form>
            </div>

          </main>
        </div>
      </div>
    </div>
  );
};

export default BusinessDetails;
